import { render, staticRenderFns } from "./BasicsSupplier.vue?vue&type=template&id=bfe14b28&scoped=true"
import script from "./BasicsSupplier.vue?vue&type=script&lang=js"
export * from "./BasicsSupplier.vue?vue&type=script&lang=js"
import style0 from "./BasicsSupplier.vue?vue&type=style&index=0&id=bfe14b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe14b28",
  null
  
)

export default component.exports